import Vue from "vue";
import CONFIG from "../configs/index.js";
import { webInfoHzc } from '../configs/sys/hzc.js';
import { webInfoHzyc } from '../configs/sys/hzyc.js';

/**
 * 从后台获取配置信息
 * 并对其进行处理
 * 将其进行挂载
 * 与mixins中的page配合使用
 * @param {Object} context 插件上下文
 */

export default async function (context) {
    const { store, app, req, isDev } = context;

    var ssrHost = "";

    let webInfo = {};
    let host = '' ;

    if (process.browser) {
        host = window.location.host;
    } else {
        host = req.headers.host;
    }

    webInfo = webInfoHzc;
    let switchObj = [
            {
                reg: /(smartproc|zchr)\./,
                comp: 'hzyc',
                webInfo:webInfoHzyc,
            },
            {
                reg: /(smartprocure)/,
                comp: 'hzc',
                webInfo:webInfoHzc,
            },
        ],
        filteredItem = switchObj.filter(item => {
            return item.reg.test(host);
        });

    if (filteredItem[0]) {
        webInfo = filteredItem[0].webInfo;
    }


    // 设置主题样式
    if (~["hzc"].indexOf(webInfo.id)) {
        require("~/assets/css/theme-hzc.scss");
    
    } else if (~["hzyc"].indexOf(webInfo.id)) {
        require("~/assets/css/theme-hzyc.scss");

    } else {
        // require("~/assets/css/element-customize.scss");
    }

    // 设置页面head
    app.head.title = webInfo.webFullName;
    // app.head.link.push({ rel: 'icon', type: 'image/x-icon', href: webInfo.iconUrl });
    app.head.link[0] = { rel: 'icon', type: 'image/x-icon', href: webInfo.iconUrl };

    // 惠智采

    // 存入store
    // store.commit("updateWebInfo", webInfo);

    // 进行全局挂载
    Vue.prototype.webInfo = webInfo;
}
